import { HelpOutline } from '@mui/icons-material';
import { Tooltip as JoyTooltip, TooltipProps, styled } from '@mui/joy';

const Tooltip = ({ placement = 'right', children, ...props }: TooltipProps) => (
  <JoyTooltip placement={placement} sx={{ maxWidth: 300 }} {...props}>
    {/* The div wrapper is needed for some children where the tooltip doesn't appear otherwise (e.g. Button) */}
    <TooltipWrapper>{children}</TooltipWrapper>
  </JoyTooltip>
);

export default Tooltip;

export const SimpleTooltip = ({ title }: { title: string }) => (
  <Tooltip title={title}>
    <TooltipIcon />
  </Tooltip>
);

const TooltipWrapper = styled('div')(() => ({
  display: 'inline-block',
  verticalAlign: 'bottom',
}));

export const TooltipIcon = styled(HelpOutline)(({ theme: { palette } }) => ({
  width: '14px',
  height: '14px',
  marginTop: '2px',
  color: palette.grey4,
}));
